import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { AppBar, Typography, IconButton, Box } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

//styles
import themes from "../../themes/defaultTheme";

export default function InfoBanner({ hasSubHeader = false, onVisibilityChange, roadwaysBannerMsg }) {
    const [isVisible, setIsVisible] = useState(true);
    const showBanner = process.env.REACT_APP_SHOW_INFO_BANNER === 'true';
    const infoBannerMsg = process.env.REACT_APP_INFO_BANNER_MESSAGE;
    const hasAnyMessage = (showBanner && infoBannerMsg) || roadwaysBannerMsg?.text;
    const isBannerActive = hasAnyMessage && isVisible;
    useEffect(() => {
        if (onVisibilityChange) {
            onVisibilityChange(isBannerActive);
        }
    }, [isBannerActive, onVisibilityChange]);
    if (!isBannerActive) {
        return null;
    }
    const handleClose = () => {
        setIsVisible(false);
    };
    return (
        <AppBar
            id="info-banner"
            tabIndex={-1}
            position="fixed"
            role="alert"
            aria-live="polite"
            sx={{
                backgroundColor: themes.default.palette.secondary.light,
                top: hasSubHeader ? { xs: '104px', sm: '112px' } : { xs: '56px', sm: '64px' },
                boxShadow: 1,
                zIndex: 1400
            }}
        >
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '12px 20px'
            }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>

                    {/* Render both messages if present */}
                    {showBanner && infoBannerMsg && (
                        <Typography
                            variant="body2"
                            sx={{
                                color: themes.default.palette.secondary.contrastText,
                                marginRight: roadwaysBannerMsg ? 2 : 0
                            }}
                        >
                            {infoBannerMsg}
                        </Typography>
                    )}
                    {roadwaysBannerMsg && (
                        typeof roadwaysBannerMsg === "object" && roadwaysBannerMsg.text ? (
                            <Typography
                                variant="body2"
                                sx={{
                                    color: themes.default.palette.secondary.contrastText
                                }}
                            >
                                {roadwaysBannerMsg.text}
                                {roadwaysBannerMsg.link && (
                                    <Link
                                        to={roadwaysBannerMsg.link.to}
                                        role="link"
                                        aria-label={roadwaysBannerMsg.link.to ? roadwaysBannerMsg.link.to.replaceAll("/", "").replaceAll("-", " ") : roadwaysBannerMsg.link.label}
                                        style={{ color: themes.default.palette.secondary.contrastText, textDecoration: "underline", fontWeight: "bold" }}
                                    >
                                        {roadwaysBannerMsg.link.label}
                                    </Link>
                                )}
                            </Typography>
                        ) : roadwaysBannerMsg.link && (
                            <Typography
                                variant="body2"
                                sx={{
                                    color: themes.default.palette.secondary.contrastText
                                }}
                            >
                                {roadwaysBannerMsg}
                            </Typography>
                        )
                    )}
                </Box>
                <IconButton
                    aria-label="Close information banner"
                    size="small"
                    onClick={handleClose}
                    sx={{
                        marginLeft: 2,
                        color: themes.default.palette.secondary.contrastText
                    }}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </Box>
        </AppBar>
    );
}